import { TranslationMapType, TranslationOptionsType } from 'types'

// Common language options
const options: TranslationOptionsType = {
  formats: {
    dateLong: 'D MMMM YYYY',
    dateTimeLong: 'D MMMM YYYY, hh:mm',
    dateShort: 'D MMM XXXX',
    dateTimeShort: 'D MMM XXXX hh:mm',
  },
  names: {
    months: [
      'januari',
      'februari',
      'mars',
      'april',
      'maj',
      'juni',
      'juli',
      'augusti',
      'september',
      'oktober',
      'november',
      'december',
    ],
    monthsShort: [
      'jan',
      'feb',
      'mar',
      'apr',
      'maj',
      'jun',
      'jul',
      'aug',
      'sep',
      'okt',
      'nov',
      'dec',
    ],
  },
  price: {
    currencyShort: 'kr',
    decimalSymbol: ',',
  },
}

// Common translations
const translations: TranslationMapType = {
  'general.account': 'Konto',
  'general.account_administrator': 'Konto\u00ADadministratör',
  'general.account_administrators': 'Konto\u00ADadministratörer',
  'general.accounts': 'Konton',
  'general.active_buyer_count': {
    param: 'count',
    '=1': 'Aktiv köpare',
    _: 'Aktiva köpare',
  },
  'general.add': 'Lägg till',
  'general.add_invoice_recipient': 'Lägg till faktura\u00ADmottagare',
  'general.add.principal': 'Lägg till verklig huvudman',
  'general.logged_in_user_info': 'Jag är sökande',
  'general.address': 'Adress',
  'general.address_row_1': 'Adressrad 1',
  'general.address_row_2': 'Adressrad 2',
  'general.invoice_address': 'Fakturaadress',
  'general.invoice_address_row_1': 'Fakturaadress 1',
  'general.invoice_address_row_2': 'Fakturaadress 2',
  'general.amount': 'Belopp',
  'general.amount_excl_vat': 'Momsgrund',
  'general.app_name': 'Fakturatjänst',
  'general.app_name_short': 'Fakturatjänst',
  'general.back': 'Tillbaka',
  'general.cancel': 'Avbryt',
  'general.capital': 'Eget Kapital',
  'general.city': 'Ort',
  'general.change': 'Ändra',
  'general.confirm': 'Bekräfta',
  'general.confirm_email': 'Bekräfta e-post',
  'general.contact_information': 'Kontakt\u00ADinformation',
  'general.contact_person': 'Kontaktperson',
  'general.country': 'Land',
  'general.created': 'Skapad',
  'general.create_new_account_administrator':
    'Skapa ny konto\u00ADadministratör',
  'general.create_new_customer': 'Skapa ny kund',
  'general.create_new_invoice_recipient': 'Skapa ny faktura\u00ADmottagare',
  'general.create_new_account': 'Skapa nytt konto',
  'general.create_new_organization_administrator':
    'Skapa ny organisations\u00ADadministratör',
  'general.create_new_purchaser': 'Skapa ny köpare',
  'general.customer_created': 'Kund skapad',
  'general.date': 'Datum',
  'general.date_and_time': 'Datum & tid',
  'general.delete': 'Ta bort',
  'general.delete_invoice_recipient': 'Ta bort faktura\u00ADmottagaren',
  'general.delete_account': 'Ta bort konto',
  'general.delete_discount': 'Ta bort rabatt',
  'general.details': 'Detaljer',
  'general.discount': 'Rabatt',
  'general.no_discount': 'Ej rabatt',
  'general.discounts': 'Rabatter',
  'general.none_discount': 'Ingen rabatt',
  'general.do_not_inform_customer': ' (Förmedla ej detta till kund)',
  'general.edit': 'Ändra',
  'general.edit_account_administrator': 'Ändra konto\u00ADadministratör',
  'general.edit_invoice_recipient': 'Ändra faktura\u00ADmottagare',
  'general.edit_account': 'Ändra konto',
  'general.edit_organization_administrator':
    'Ändra organisations\u00ADadministratör',
  'general.edit_purchaser': 'Ändra köpare',
  'general.email': 'E-post',
  'general.email-address': 'E-postadress',
  'general.expiration_date': 'Förfallo\u00ADdatum',
  'general.export': 'Exportera',
  'general.export_as_pdf': 'Exportera som pdf',
  'general.export_invoice_as_pdf': 'Ladda ner faktura',
  'general.export_invoice_specification_as_excel':
    'Ladda ner fakturaspecifikation',
  'general.export_administrators': 'Exportera administratörer',
  'general.export_payment_purchasers': 'Exportera köpare',
  'general.export_transactions': 'Exportera transaktioner',
  'general.copy_invoice_recipient': 'Kopiera fakturamottagare',
  'general.copy_invoice_recipient_help_text':
    'Skapa snabbt en ny fakturamottagare genom att kopiera befintliga adressuppgifter! Observera att eventuella köpare, administratörer eller vissa fakturareferenser inte kopieras.',
  'general.select_invoice_recipient': 'Välj fakturamottagare att kopiera',
  'general.create_without_buyer_order_reference':
    'Vill du skapa eller ändra en fakturamottagare utan köpare- eller orderreferens?',
  'general.fee': 'Avgift',
  'general.fees': 'Avgifter',
  'general.feeRows': 'Avgiftsrader',
  'general.filter_on_date': 'Filtrera på datum',
  'general.filter_on_invoice_recipient': 'Filtrera på faktura\u00ADmottagare',
  'general.filter_on_name': 'Filtrera på namn',
  'general.filter_on_purchaser': 'Filtrera på köpare',
  'general.filter_on_status': 'Filtrera på status',
  'general.filter_on_store': 'Filtrera på butik',
  'general.first_name': 'Förnamn',
  'general.frequency': 'Frekvens',
  'general.format': 'Format',
  'general.grouping': 'Gruppering',
  'general.handle': 'Hantera',
  'general.help': 'Hjälp',
  'general.identify_yourself_in_with_bankid': 'Identifiera dig med BankID',
  'general.inactivate': 'Inaktivera',
  'general.inactivate_purchaser': 'Inaktivera köpare',
  'general.invoice': 'Faktura',
  'general.invoice_date': 'Faktura\u00ADdatum',
  'general.invoice_delivery_intermediator':
    'E-faktura via Peppol eller annan operatör (VAN)',
  'general.invoice_delivery_addressee_id': 'GLN- / Organisationsnummer',
  'general.invoice_delivery_method': 'Faktura\u00ADleverans',
  'general.invoice_number': 'Faktura\u00ADnummer',
  'general.invoice_recipient': 'Faktura\u00ADmottagare',
  'general.invoice_recipient_admin':
    'Faktura\u00ADmottagar\u00ADadministratörer',
  'general.create_new_invoice_recipient_admin':
    'Skapa ny faktura\u00ADmottagar\u00ADadministratör',
  'general.edit_invoice_recipient_admin':
    'Ändra faktura\u00ADmottagar\u00ADadministratör',
  'general.invoice_recipient_admins':
    'Faktura\u00ADmottagar\u00ADadministratörer',
  'general.invoice_recipient_pdf': 'Fakturamottagare',
  'general.invoice_recipients': 'Faktura\u00ADmottagare',
  'general.invoice_settings': 'Faktura\u00ADinställningar',
  'general.invoice_delivery_settings': 'Faktura\u00ADleverans\u00ADmetod',
  'general.invoices': 'Fakturor',
  'general.invoicing': 'Fakturering',
  'general.invoiced': 'Fakturerad',
  'general.not_invoiced': 'Ej fakturerad',
  'general.kim_id': 'KimID',
  'general.last_name': 'Efternamn',
  'general.limit': 'Gräns',
  'general.log_in': 'Logga in',
  'general.log_in_with_bankid': 'Logga in med BankID',
  'general.log_in_with_mobile_bankid': 'Logga in med Mobilt BankID',
  'general.log_out': 'Logga ut',
  'general.logging_out': 'Loggar ut...',
  'general.name': 'Namn',
  'general.account_name': 'Kontonamn',
  'general.name_in_app': 'Namn i appen',
  'general.name_on_invoice': 'Namn på fakturor',
  'general.name_of_invoice_recipient': 'Namn på Fakturamottagare',
  'general.previous': 'Tidigare',
  'general.next': 'Nästa',
  'general.no': 'Nej',
  'general.not_a_receipt_row_1': 'Detta är inte ett kvitto.',
  'general.not_a_receipt_row_2':
    'Momsavdrag kan inte yrkas med stöd av denna handling.',
  'general.number_of_employees': 'Antal Anställda',
  'general.number_per_page': 'Antal per sida',
  'general.manual_discount': 'Manuella rabatter',
  'general.of': 'av',
  'general.of_count': 'av {count}',
  'general.ok': 'OK',
  'general.or': 'eller',
  'general.organisation': 'Organisation',
  'general.organization_account': 'Organisations\u00ADkonto',
  'general.organization_accounts': 'Organisations\u00ADkonton',
  'general.organisation_number': 'Organisations\u00ADnummer',
  'general.organization_admins': 'Organisations\u00ADadministratörer',
  'general.organization_admin': 'Organisations\u00ADadministratör',
  'general.organization_name': 'Namnet på organisationen',
  'general.organization_number': 'Organisations\u00ADnummer',
  'general.organizations_revenues_including_assets':
    'Rörelsens intäkter (inkl bidrag & anläggningstillgångar)',
  'general.page': 'Sida',
  'general.payment_terms': 'Betalnings\u00ADvillkor',
  'general.payment_purchaser': 'Köpare',
  'general.payment_purchasers': 'Köpare',
  'general.pep': 'PEP',
  'general.personal_id': 'Person\u00ADnummer',
  'general.personal_details': 'Person\u00ADuppgifter',
  'general.phone': 'Telefon',
  'general.price_excl_vat': 'Pris exkl. moms',
  'general.principal': 'Verklig huvudman',
  'general.purchase': 'Köp',
  'general.purchase_limit': 'Inköpsgräns',
  'general.purchase_limit_internal': 'Köputrymme',
  'general.risk_class': 'Riskklass',
  'general.purchase_limit_per_month': 'Inköpsgräns per månad',
  'general.purchase_specification_number':
    'Köp\u00ADspecifikations\u00ADnummer',
  'general.purchase_specification_number_pdf': 'Köpspecifikationsnummer',
  'general.purchaser': 'Köpare',
  'general.purchasers': 'Köpare',
  'general.purchases': 'Köp',
  'general.purchaseRows': 'Köprader',
  'general.purchasing_information': 'Inköpsinformation',
  'general.quit': 'Avsluta',
  'general.receipt': 'Kvitto',
  'general.receipt_total': 'Kvittototal',
  'general.reference': 'Referens',
  'general.reference_count': 'Referens {count}',
  'general.reference_person': 'Referensperson',
  'general.reference_order': 'Orderreferens',
  'general.reference_buyer': 'Beställarreferens',
  'general.reference_contract': 'Kontraktsreferens',
  'general.references': 'Fakturareferenser',
  'general.remember_personal_id_on_this_unit':
    'Kom ihåg mitt person\u00ADnummer på den här enheten',
  'general.remove': 'Ta bort',
  'general.replace_file': 'Ersätt fil',
  'general.reset_filters': 'Nollställ filter',
  'general.result': 'Resultat',
  'general.review': 'Sammanställning',
  'general.role': 'Funktion',
  'general.save': 'Spara',
  'general.search': 'Sök',
  'general.select': 'Välj',
  'general.select_organisation': 'Välj organisation',
  'general.share': 'Andel',
  'general.show': 'Visa',
  'general.sign_and_send': 'Signera & skicka in',
  'general.signatory': 'Sökande',
  'general.signatories': 'Sökande',
  'general.staff_costs': 'Personalkostnader',
  'general.status': 'Status',
  'general.store': 'Butik',
  'general.total_count_items': {
    param: 'count',
    '=1': 'Totalt 1 vara',
    _: 'Totalt {count} varor',
  },
  'general.total_sum_excluding_vat': 'Summa exkl. moms',
  'general.total_sum_including_vat': 'Summa inkl. moms',
  'general.total_vat': 'Momsbelopp',
  'general.turnover': 'Omsättning',
  'general.upload_file': 'Ladda upp fil',
  'general.uploading_file': 'Laddar upp fil',
  'general.user': 'Användare',
  'general.users': 'Användare',
  'general.zipcode': 'Post\u00ADnummer',
  'general.transactions': 'Transaktioner',
  'general.transaction': 'Transaktion',
  'general.item': 'Vara',
  'general.price': 'Pris',
  'general.unpaid_invoices': 'Obetalda fakturor',
  'label.purchase_limit_message': {
    param: 'limit',
    _: 'Total inköpsgräns för din organisation: {limit} kr. ',
  },
  'label.limit_explain_text':
    'Organisationens totala inköpsgräns gäller per kalendermånad. Även om en köpare har en högre inköpsgräns kan organisationens inköpsgräns inte överskridas. Köpare kan kontrollera hur mycker de kan handla för genom att logga in i mobilappen.',
  'general.unpaid_invoices_count': {
    param: 'count',
    '=1': 'Obetald faktura',
    _: 'Obetalda fakturor',
  },
  'general.delayed_invoices': 'Försenade fakturor',
  'general.delayed_invoices_count': {
    param: 'count',
    '=1': 'Försenad faktura',
    _: 'Försenade fakturor',
  },
  'general.telephone_number': 'Telefon\u00ADnummer',
  'general.mobile_number': 'Mobil\u00ADnummer',
  'general.mobile_number_ex_010': 'Mobil\u00ADnummer (ej 010-nummer)',
  'general.vat': 'Moms',
  'general.vat_class': 'Momsklass',
  'general.yes': 'Ja',
  'general.sammanstallning_required': 'Lägg till denna information',
  'general.continue': 'Fortsätt',
  'general.show_document': 'Visa dokument',
  'general.submit': 'Skicka in',

  'label.currency_short': 'kr',
  'label.amount_short': 'st',
  'label.personal_id_placeholder': 'ÅÅÅÅMMDDXXXX',
  'label.mobile_number_placeholder': 'XXXXXXXXXX',
  'label.application_in_progress_header':
    'En ansökan pågår redan för organisationen',
  'label.application_in_progress_description':
    'Eftersom det redan finns en påbörjan ansökan till Fakturatjänsten för er organisation så måste denna färdigställas eller avbrytas innan en ny kan påbörjas.',
  'label.organization_already_customer_header':
    'Organisationen har redan Fakturatjänsten',
  'label.organization_already_customer_description':
    'Eftersom er organisation redan har Fakturatjänsten som betalmedel för inköp i Coop så behöver vi hjälpa dig utanför den ordinarie ansökan.',
  'label.organization_number_placeholder': 'XXXXXXXXXX',
  'label.organization_name_hint': 'Samma namn som hos Bolagsverket',
  'label.abort': 'Avbryt',
  'label.food_company': 'Livsmedelsföretag',
  'label.food_company_question': 'Är organisationen ett livsmedelsföretag?',
  'label.food_company_hint':
    'Om ni är registrerade hos kommunen som ett livsmedelsföretag ska detta anges. Med livsmedelsföretag menas alla företag som med eller utan vinstsyfte bedriver en verksamhet som antingen producerar, bearbetar eller distribuerar livsmedel (ex. förskola, butik, restaurang). Syftet med att ange denna information är att fullfölja krav gällande spårbarhet av livsmedel.',

  // Info alerts
  'alert.openBankIdApp': 'Öppna BankId-appen',
  // Errors & warnings
  'alert.UNKNOWN_ERROR': 'Ett fel har uppstått. Försök igen.',
  'alert.NETWORK_ERROR': 'Ett nätverksfel har uppstått. Försök igen.',
  'alert.NETWORK_TIMEOUT':
    'Servern tog för lång tid på sig att svara. Försök igen.',
  'alert.SERVER_ERROR': 'Ett serverfel har uppstått. Försök igen.',
  'alert.PAGE_NOT_FOUND': 'Sidan kunde inte hittas.',
  'alert.NO_LOGIN': 'Inloggning krävs för att se sidan.',
  'alert.ACCESS_DENIED': 'Du har inte åtkomst till sidan.',
  'alert.INVALID_LOGIN_STATE': 'Inloggningen tog för lång tid. Försök igen.',
  'alert.LOGIN_EXPIRED_LOGGED_OUT':
    'Du har loggats ut efter en tids inaktivitet.',
  'alert.INVALID_FILE_TYPE': 'Filtypen är inte tillåten',
  'alert.INVALID_FILE_TYPE_WITH_ALLOWED_TYPES':
    'Filtypen är inte tillåten (tillåtna typer: {allowedFileTypes})',
  'alert.PERSON_NOT_FOUND': 'Användaren kunde inte hittas.',
  'alert.PERSON_NOT_ADMIN': 'Användaren är inte administratör.',
  'alert.NO_ORGANIZATIONS_FOUND_FOR_PERSON':
    'Användaren har inte tillgång till några organisationer eller konton',
  'alert.ORGANIZATION_ALREADY_CUSTOMER':
    'Denna organisation har redan Fakturatjänsten',
  'alert.APPLICATION_IN_PROGRESS':
    'En ansökan till fakturatjänst är redan pågående',
  'alert.PERSON_IS_ALREADY_AN_ORGANIZATION_ADMIN':
    'Personen har redan en behörighet på denna organisation',
  'alert.swedish_zip_code':
    'Svenska postnummer får endast bestå av fem siffror (skriv ej med mellanslag)',
  'alert.PARAMETER_VALIDATION_ERROR': 'Formuläret är inte giltigt',
  'alert.OVERLAPPING_DISCOUNT_PERIOD': 'Överlappande perioder',
  'alert.DISCOUNT_NOT_FOUND': 'Rabatt hittades inte',
  'alert.DISCOUNT_NOT_ACTIVE': 'Rabatt inte aktiv',
  'alert.DISCOUNT_NOT_PENDING': 'Rabatten väntar inte',
  'alert.ATTACHMENT_NOT_FOUND': 'Bilagan hittades inte',
  'alert.COULD_NOT_UPDATE_ORGANIZATION': 'Kunde inte ändra organisationen',
  'alert.ORGANIZATION_UPDATED': 'Organisationen uppdaterad',

  // Validation
  'validation.emailExpected': 'E-postadress krävs',
  'validation.orgNumberExpected':
    'Giltigt 10-siffrigt organisations\u00ADnummer krävs',
  'validation.personalIdExpected':
    'Giltigt 12-siffrigt person\u00ADnummer (ÅÅÅÅMMDDXXXX) krävs',
  'validation.positiveIntegerExpected': 'Heltal större än noll krävs',
  'validation.integerExpected': 'Heltal krävs',
  'validation.wholeNumberExpected': 'Ange belopp i hela 1000-tal',
  'validation.required': 'Obligatoriskt',
  'validation.sameEmailExpected': 'Samma e-postaddress krävs',
  'validation.telephoneNumberExpected': 'Telefonnummer krävs',
  'validation.swedishZipCodeExpected': 'Postnummer (5 siffror) krävs',
  'validation.zipCodeExpected': 'Felaktigt postnummer',
  'validation.invalidCharacter': 'Otillåtet tecken',
  'validation.atMostFiftyCharacters': 'Får ej vara längre än 50 tecken.',
  'validation.answerRequired': 'Obligatoriskt att svara på frågan ovan',
}

export { options, translations }
